import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Row, Pagination, Select } from 'antd';

import Trick from '@components/trick/Trick';
import Search from 'antd/lib/input/Search';
import { requests } from '@utils/api';
import Loader from '@components/loader/loader';
import { useLocation } from 'react-router';
import { history } from '../../redux/store';
import Bundle from '@components/bundle/Bundle';

type Props = {};

const CoreProgramme: React.FC<Props> = () => {
  const { t } = useTranslation('genericScreen');
  const topics = useSelector((state: IReducerStates) => state.global.topics);
  const [fetching, setFetching] = useState(true);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    keyword: '',
    topic: ''
  });
  const [tricksCollection, setTricksCollection] = useState({
    data: [],
    page: 1,
    pages: 1,
    count: 0
  });
  const dispatch = useDispatch();
  const search = useLocation().search;

  useEffect(() => {
    let page = new URLSearchParams(search).has('p')
      ? parseInt(new URLSearchParams(search).get('p'))
      : 1;
    setPage(page);
    loadData(page, filters);
  }, [dispatch]);

  const onSearch = (keyword: string) => {
    let newFilters = { ...filters, keyword: keyword };
    setFilters(newFilters);
    loadData(1, newFilters);
  };

  const loadData = async (page: number, filters: { keyword: string; topic: string }) => {
    await setFetching(true);
    await requests
      .get(`/v1/bundles/?p=${page}&s=${filters.keyword}&t=${filters.topic}&tid=16`)
      .then(data => {
        setTricksCollection(data);
      })
      .catch(err => {
        console.log(err);
      });
    setFetching(false);
  };

  return (
    <>
      <Row justify="center" align="top" style={{ marginTop: '40px' }}>
        <Col xs={22} sm={18} md={18} lg={18} xl={18} className="whiteContainer">
          <h1 className="title">{t('core_programme')}</h1>

          <Search
            placeholder={t('search')}
            allowClear
            onSearch={onSearch}
            className="tricks-filter-big"
          />
          {topics && (
            <Select
              placeholder={t('select_topic')}
              className="tricks-filter-mid"
              options={topics.data.map(item => {
                return { value: item.name, label: item.name };
              })}
              allowClear={true}
              onChange={value => {
                let newFilters = { ...filters, topic: value ? String(value) : '' };
                setFilters(newFilters);
                loadData(1, newFilters);
              }}
            />
          )}
          <div style={{ clear: 'both' }} />

          {fetching && <Loader />}
          {!fetching && (
            <>
              <Row>
                {tricksCollection.data.map((item, index) => (
                  <Col xs={24} sm={24} md={12} lg={6} style={{ marginTop: '10px' }}>
                    <Bundle bundle={item} />
                  </Col>
                ))}
              </Row>
              <div className="clearfix" />
              <Pagination
                onChange={newPage => {
                  history.push(`${window.location.pathname}?p=${newPage}`);
                  loadData(newPage, filters);
                  setPage(newPage);
                }}
                current={page}
                showSizeChanger={false}
                total={tricksCollection.count}
                pageSize={30}
                responsive={true}
                style={{ margin: 'auto auto', maxWidth: 250 }}
              />
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default CoreProgramme;
